module.exports = __webpack_public_path__ + "media/images/indicators/spi-f7ba81698817c42c333854cf8272f753.png";